import React from 'react';
import itemGridStyle from './style';

export default function DSKGrid({rows, title = false, mt, subtitle, smallTitles}) {
	let style = itemGridStyle();
	let hasTitle = title || subtitle || smallTitles;

	function Row({children, cols, i}) {
		let isOdd = i % 2 !== 0;
		return (
			<div key={Math.random()} style={style.rowContainerStyle({isOdd: isOdd})}>
				{cols.map((col, j) => {
					let isHeader = i === 0;
					return (
						<p
							key={Math.random()}
							style={style.textStyle({isHeader: isHeader})}
							className={style.textClasses({entrys: cols.length})}
						>
							{col}
						</p>
					);
				})}
			</div>
		);
	}

	return (
		<div style={style.outerStyle({mt: mt})}>
			{title ? <h1 style={style.titleStyle()}>{title}</h1> : <></>}
			{smallTitles ? (
				smallTitles.map((smallTitle, j) => {
					return (
						<h1 className={`mt-${j !== 0 ? '3' : '0'} nice-header text-center text-black`} key={j}>
							{smallTitle}
						</h1>
					);
				})
			) : (
				<></>
			)}
			{subtitle ? <p className='mt-5 px-3'>{subtitle}</p> : <></>}
			<div className={`${hasTitle ? 'mt-3' : ''}`}></div>
			{rows ? (
				rows.map((cols, i) => {
					return <Row cols={cols} i={i} key={Math.random()} />;
				})
			) : (
				<></>
			)}
		</div>
	);
}
